import { useState, useEffect } from "react";
import { Box, TextField, Grid, Paper, Select, MenuItem } from "@mui/material";
import FormLabel from "../../components/FormLabel";
import { resolveErrMsg, getUserData } from "../../utils/utilities";
import axios from "../../config/axios";
import CommonDialog from "../../components/CommonDialog";

const UserDetails = (props) => {
  const [validations, setValidations] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);

  const role = props.data.role;

  // other functions
  const handleChange = (field, value) =>
    props.setData((prevState) => ({
      ...prevState,
      [field]: value,
    }));

  const handleCloseModal = () => {
    props.setOpen(false);
  };

  // API Services
  const updateUserDetails = () => {
    setBtnLoader(true);
    const params = {
      id: props.data._id,
    };

    const body = {
      email: props.data.email,
      name: props.data.name,
      // isSuper: props.data.isSuper,
    };

    if (role == "SuperAdmin" && props?.companyList?.length > 0) {
      body.company = props.data.company_id;
    }

    let url = "";

    if (role == "SuperAdmin") {
      url = "/super-admin/update";
    } else {
      url = "user/update";
    }

    axios
      .put(url, body, { params })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status) {
            props.setAlert({
              variant: "success",
              msg: res.data.message,
              status: true,
            });
            props.setData({});
            setBtnLoader(false);
            handleCloseModal();
            props.getList();
          } else {
            if (res.data.type === "validation") {
              const tempVal = {};
              res.data.error?.forEach((err) => {
                tempVal[err.field] = resolveErrMsg(err.type);
              });
              setValidations(tempVal);
            }
            if (res.data.type === "error") {
              props.setAlert({
                variant: "error",
                msg: res.data.error?.message,
                status: true,
              });
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setBtnLoader(false);
      });
  };

  useEffect(() => {
    if (props.data && props.data?.companyId) {
      handleChange("company_id", props.data.companyId);
    }
    return () => {
      props.setData({});
    };
  }, []);

  return (
    <CommonDialog
      open={props.open}
      title={props.title || "Edit Profile"}
      onSubmit={updateUserDetails}
      onClose={handleCloseModal}
      loading={btnLoader}
      submitLabel="Update"
    >
      <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
        <Box style={{ padding: "10px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <FormLabel title="Name" />
              <TextField
                fullWidth
                placeholder="Name"
                size="small"
                error={validations.name}
                helperText={validations.name || ""}
                value={props.data.name || ""}
                onChange={(e) => handleChange("name", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <FormLabel title="Email" />
              <TextField
                fullWidth
                placeholder="Email"
                size="small"
                error={validations.email}
                helperText={validations.email || ""}
                value={props.data.email || ""}
                onChange={(e) => handleChange("email", e.target.value)}
              />
            </Grid>
            {!role == "SuperAdmin" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormLabel title="Role" />
                <Select
                  placeholder="Role"
                  size="small"
                  value={props.data.role}
                  onChange={(e) => handleChange("role", e.target.value)}
                  fullWidth
                >
                  <MenuItem value={"Admin"}> Employee </MenuItem>
                  <MenuItem value={"CompanyAdmin"}>Company Admin</MenuItem>
                </Select>
              </Grid>
            )}

            {role == "SuperAdmin" && props?.companyList?.length > 0 && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormLabel title="Company" />
                <Select
                  placeholder="Company"
                  size="small"
                  value={props.data.company_id || false}
                  onChange={(e) => handleChange("company_id", e.target.value)}
                  fullWidth
                >
                  <MenuItem disabled value="">
                    <em>Select Company</em>
                  </MenuItem>
                  {props?.companyList?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            )}
          </Grid>
        </Box>
      </Paper>
    </CommonDialog>
  );
};

export default UserDetails;
